import { PartnerType } from 'legacy/lut/classes/models/PartnerType'
import { ScopeSelectKeys } from 'legacy/lut/components/widgets/public/partner360/composedReport/models'

import { IComposedReportState } from './models/state'

export const initialSelectsData = {
  geo: [],
  products: [],
  scopeValue: ScopeSelectKeys.All,
  amplifyMembership: [],
  acknowledged: [],
  managers: [],
  pbms: [],
  specializations: [],
  partnersInScope: [],
  fYear: 0,
  partnersType: PartnerType.Commercial,
  isAcknowledged: false,
}

export const initialState: IComposedReportState = {
  isOpenScopeEditor: false,
  isShowScopeSection: false,
  lastAppliedFilter: null,
  isFilterApplied: false,
  openedFilterData: null,
  isForceOpenedGlobalsModal: false,
  ...initialSelectsData,
}
